import React from "react";

import NotificacoesCovid from "./index";

export default function Routes() {
  return [
    {
      props: {
        path: "/notificacoesCovid",
        isPrivate: true,
        exact: true,
      },
      componente: <NotificacoesCovid />,
    },
  ];
}




